export default [
  {
    name: 'getByRedis',
    method: 'GET',
    path: '/PF/Form/GetByRedis',
    params: {
      Key: '',
      OrgId: ''
    },
    desc: '获取表单配置'
  },
  {
    name: 'getCustomPageConfigInfo',
    method: 'POST',
    path: '/PF/PageCustom/GetCustomPageConfigInfo',
    params: {
      Keyword: '',
      OrgId: ''
    },
    desc: '获取自定义表单配置'
  },
  {
    name: 'getEnums',
    method: 'GET',
    path: '/PF/Extend/GetEnums',
    params: {},
    axiosOptions: {
      noAttachedData: true
    },
    desc: '获取枚举'
  },
  {
    name: 'getServerTime',
    method: 'GET',
    path: '/PF/HomePage/GetCurrentTime',
    params: {},
    axiosOptions: {},
    desc: '获取服务器时间'
  },
  {
    name: 'getImportConfig',
    method: 'POST',
    path: '/PF/ImportConfig/GetImportConfig',
    params: {},
    axiosOptions: { fullData: true },
    desc: '获取导入配置'
  },
  {
    name: 'getConfig',
    method: 'GET',
    path: '/OP/Sys/GetConfig',
    params: {},
    axiosOptions: {},
    desc: '获取参数配置'
  },
]